import React from 'react'
import { cn } from '@/lib/utils'
import { useTabSwitch } from '../../hooks'
import { Nav, NavLink, NavItem, TabContent, TabPane } from '@/components/ui-compat'
import UsersTable from './components/UsersTable.tsx'
import ProjectsTable from './components/ProjectsTable'
import OrganizationInfo from './components/OrganizationInfo'
import Documents from './components/Documents'
import RolesTab from './components/RolesTab'
import { Info, FolderKanban, Users, FileText, ShieldCheck } from 'lucide-react'

import { useTranslation } from 'react-i18next'

export default () => {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useTabSwitch()

  return (
    <>
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold mb-0">{t('Organization_screen _organization_settings_label')}</h1>
      </div>
      <div className="tab">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={cn('flex items-center', { active: activeTab === 'info' })}
              onClick={() => setActiveTab('info')}
            >
              <Info className="h-4 w-4 mr-2" />
              {t('Organization_info_info_tablabel')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={cn('flex items-center', { active: activeTab === 'projects' })}
              onClick={() => setActiveTab('projects')}
            >
              <FolderKanban className="h-4 w-4 mr-2" />
              {t('Organization_projects_projects_tablabel')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={cn('flex items-center', { active: activeTab === 'users' })}
              onClick={() => setActiveTab('users')}
            >
              <Users className="h-4 w-4 mr-2" />
              {t('Organization_users_users_tablabel')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={cn('flex items-center', { active: activeTab === 'roles' })}
              onClick={() => setActiveTab('roles')}
            >
              <ShieldCheck className="h-4 w-4 mr-2" />
              {t('Organization_roles_roles_tablabel', 'Roles & permissions')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={cn('flex items-center', { active: activeTab === 'documents' })}
              onClick={() => setActiveTab('documents')}
            >
              <FileText className="h-4 w-4 mr-2" />
              {t('Organization_documents_documents_tablabel')}
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="info">
            <OrganizationInfo />
          </TabPane>
          <TabPane tabId="projects">
            <ProjectsTable />
          </TabPane>
          <TabPane tabId="users">
            <UsersTable />
          </TabPane>
          <TabPane tabId="roles">
            <RolesTab />
          </TabPane>
          <TabPane tabId="documents">
            <Documents />
          </TabPane>
        </TabContent>
      </div>
    </>
  )
}
